if($('.product').length){
    function mhProducts(){
        $('.product').each(function(){
            if($(this).find('.widget-parameter-wrapper').length){
                $(this).find('.ratings-wrapper').append($(this).find('.widget-parameter-wrapper'))
            }
            else{
                $(this).find('.ratings-wrapper').append('<div class="widget-parameter-wrapper-empty"></div>')
            }
        })
    }
    $(document).ready(function(){
        mhProducts();
        loadJSON();
        displayColorData();
    })
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhProducts();
        loadJSON();
        displayColorData();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhProducts();
        loadJSON();
        displayColorData();
    });
}


   // Funkce pro načtení JSON souboru a zpracování dat
function loadJSON() {
    $.ajax({
      type: "GET",
      url: "/user/documents/variantImages/customColorsVariant.json?v=" + new Date().getUTCMinutes(),
      dataType: "json",
      success: function(data) {
        // Uložíme data do sessionStorage
        sessionStorage.setItem('colors', JSON.stringify(data));
      }
    });
  }
  
  // Funkce pro zobrazení dat o barvách na stránce
  function displayColorData() {
    setTimeout(function() {
      // Načtení uložených dat ze sessionStorage
      var storedColors = JSON.parse(sessionStorage.getItem('colors'));
  
      // Projdeme všechny produkty
      $(".product .widget-parameter-value a").each(function() {
        var title = $(this).attr("title").split(':')[1].trim();
  
        if (storedColors) {
          // Najdeme odpovídající barvu podle názvu
          var color = storedColors.find(function(item) {
            return item.color_name === title;
          });
  
          // Pokud existuje odpovídající barva
          if (color) {
            console.log(color)
            if (color.image_url) {
              // Pokud má barva obrázek
              $(this).addClass('haveImage');
              $(this).attr('style', 'background-image:url(' + color.image_url.replace('uploads/', '/user/documents/variantImages/') + ');background-size: 100% auto;');
            } else if (color.hex_code) {
              // Pokud má barva primární HEX kód
              $(this).attr('style', 'background-color:' + color.hex_code + ';');
            }
  
            // Pokud má sekundární HEX kód (volitelné použití)
            if (color.secondary_hex_code) {
              $(this).attr('data-secondary-color', color.secondary_hex_code);
            }
          }
        }
      });
    }, 250);
  }
  



const flagImageEntries = Object.entries(flagImageMap);

function addImagesToFlags() {
  const selectors = flagImageEntries
    .map(([flagClass]) => `.flags .flag.${flagClass}`)
    .join(',');

  if (!selectors) return;

  $(selectors).each(function () {
    const $flag = $(this);

    const matched = flagImageEntries.find(([flagClass]) =>
      $flag.hasClass(flagClass)
    );

    if (!matched) return;

    const [, imageUrl] = matched;

    if ($flag.find('.flagIcon').length) return;

    const $img = $('<img>', {
      src: imageUrl,
      alt: '',
      class: 'flagIcon',
      loading: 'lazy'
    });

    $flag
      .addClass('customFlag')
      .prepend($img);
  });
}



$(document).ready(function(){
  addImagesToFlags();
})
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
  addImagesToFlags();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
  addImagesToFlags();
});